const ITEMS = [
  "Musica dal vivo",
  "Teatro di piazza",
  "Circo contemporaneo",
  "Cabaret",
  "Danza",
  "Concerti tributo",
  "Spettacoli itineranti",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      className="w-full overflow-hidden border-y av-hairline bg-[#0a0908]"
      data-testid="marquee"
    >
      <div className="av-marquee py-5 whitespace-nowrap">
        {loop.map((label, i) => (
          <span
            key={`${label}-${i}`}
            className="inline-flex items-center gap-6 px-6 font-serif-display text-2xl md:text-3xl text-[#F7F4EE]/90"
          >
            {label}
            <span className="text-[#E5A93C]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
